import React, { memo, useState } from "react";
import { validators } from "investira.sdk";
import {
  Persona,
  Stack,
  Typography,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Icon,
  IconButton,
} from "investira.react.components";

import withResponseHandling from "../../hoc/withResponseHandling";
import withMessage from "../../hoc/withMessage";

const AlertaMembrosList = memo((props) => {
  const { membro, alert, onClick } = props;

  return (
    <ListItem
      key={membro.username}
      sx={{ borderRadius: 2 }}
      secondaryAction={
        <IconButton edge="end" onClick={onClick}>
          <Icon iconName={alert ? "bell" : "bell_off"} />
        </IconButton>
      }
    >
      <ListItemAvatar>
        <Persona alt={membro.name} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="body1" color="textPrimary">
              {membro.name || membro.username}
            </Typography>
          </Stack>
        }
        secondary={
          membro.name && (
            <Typography variant="caption" color="textSecondary">
              {membro.username}
            </Typography>
          )
        }
      />
    </ListItem>
  );
});

AlertaMembrosList.propTypes = {};

export default withResponseHandling(withMessage(AlertaMembrosList));
